/* © CNES */
import { classNames } from 'primereact/utils';
import './PageHeader.scss';

/**
 * Page Header Props type.
 */
export interface PageHeaderProps {
  pageTitle: string;
  isMyDataPage: boolean;
}

/**
 * Page Header displays a header for pages.
 * @returns Element.
 */
export const PageHeader = ({ pageTitle, isMyDataPage }: PageHeaderProps) => {
  const iconClassName = classNames('IconContainer', {
    ShoppingCartIcon: isMyDataPage,
    UserCircleFullIcon: !isMyDataPage,
  });
  return (
    <>
      <div className="PageHeaderTitle">
        <div className={iconClassName}>
          {isMyDataPage ? <div className="DatabaseIcon" /> : ''}
        </div>
        <h2 className="PageTitle">{pageTitle}</h2>
      </div>
    </>
  );
};
